import { defineComponent as _defineComponent } from 'vue'
import getNextLoadingTip from '@/util/loading-tips'
import { onMounted, onUnmounted, ref, computed } from 'vue';

import LoaderDotDotDot from '@/components/loaders/DotDotDot.vue'
// import LoaderFlower from '@/components/loaders/Flower.vue'
// import LoaderSpin from '@/components/loaders/SpinnyMans.vue'
// import LoaderBoxes from '@/components/loaders/SquishingBoxes.vue'
// import LoaderPlanes from '@/components/loaders/TwoPlanes.vue'

type Props = {
    message?: string;
    fullScreen?: boolean;
    hideTips?: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'loader',
  props: {
    message: null,
    fullScreen: { type: Boolean },
    hideTips: { type: Boolean }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
    message?: string;
    fullScreen?: boolean;
    hideTips?: boolean
}


const cssClasses = computed(() => {
    let c = [];
    if(props.fullScreen) {
        c.push("full-screen");
    }
    return c;
});

const tip = ref([getNextLoadingTip()]);
const intervalRef = ref<number>(0);

onMounted(() => {
    intervalRef.value = setInterval(() => {
        tip.value = [getNextLoadingTip()];
    }, 10000, undefined); // Sticking undefined here tells typescript this is the browser variant of setInterval
})

onUnmounted(() => {
    clearInterval(intervalRef.value);
})


const __returned__ = { props, cssClasses, tip, intervalRef, getNextLoadingTip, onMounted, onUnmounted, ref, computed, LoaderDotDotDot }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})